export default function ConsumerHero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center text-white">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/tmpcn0us7el.png"
          alt="Hero background"
          className="w-full h-full object-cover"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40 z-10"></div>
      </div>

      {/* Content */}
      <div className="relative z-20 w-full max-w-screen-xl mx-auto px-8">
        <div className="md:w-3/5 lg:w-1/2 text-center md:text-left">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            Your Personal<br />Genie
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-10">
            Get instant help with daily tasks, questions, and productivity. Your intelligent genie that's always ready to assist.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 sm:gap-6">
            <a 
              href="/genie-hub/my-genies"
              className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 text-lg w-full sm:w-auto text-center"
            >
              Try It Free
            </a>
            <a 
              href="/genie-hub/my-genies" 
              className="text-gray-300 hover:text-white font-medium text-lg transition-colors duration-300"
            >
              Browse Genies &gt;
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}